import {
  FacebookIconSVG,
  LineCircleSVG,
  YoutubeIconSVG,
} from 'components/common/SVGElements'
import {
  LS_TERMS_OF_SERVICE_LINK,
  LS_PRIVACY_POLICY_LINK,
} from 'config/constants'

// 文章圖輯區塊連結
export const ARTICLE_ALBUM_LINKS = [
  {
    href: '/album',
    text: '靈感圖輯',
  },
  {
    href: '/article',
    text: '知識文章',
  },
  {
    href: 'https://livinglife.com.tw/events/edm-subscription/ ',
    text: '訂閱電子報',
    originalLink: true,
    target: '_blank',
  },
]

// 關於信義居家連結
export const ABOUT_SINYI_LINKS = [
  {
    href: 'https://livinglife.com.tw/',
    text: '信義居家官網',
    originalLink: true,
    target: '_blank',
  },
  {
    href: 'https://livinglife.com.tw/events/english-service/',
    text: 'English Service',
    originalLink: true,
    target: '_blank',
  },
  {
    href: 'https://livinglife.com.tw/mkt/join-livinglife',
    text: '信義居家廠商募集',
    originalLink: true,
    target: '_blank',
  },
  {
    href: 'https://link.livinglife.com.tw/fVJi6s',
    text: '常見問與答',
    originalLink: true,
    target: '_blank',
  },
  {
    href: LS_TERMS_OF_SERVICE_LINK,
    text: '服務條款',
    originalLink: true,
    target: '_blank',
  },
  {
    href: LS_PRIVACY_POLICY_LINK,
    text: '隱私權政策',
    originalLink: true,
    target: '_blank',
  },
  {
    text: 'ISO9001 服務品質管理認證',
  },
]

// 信義集團連結
export const SINYI_GROUP_LINKS = [
  {
    href: 'https://www.sinyi.com.tw/',
    text: '信義房屋官網',
    originalLink: true,
    target: '_blank',
  },
  {
    href:
      'https://www.sinyi.com.tw/?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer',
    text: '買屋',
    originalLink: true,
    target: '_blank',
  },
  {
    href:
      'https://www.sinyi.com.tw/sell/mytrade?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer',
    text: '賣屋',
    originalLink: true,
    target: '_blank',
  },
  {
    href:
      'https://www.sinyi.com.tw/rent/index.php?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer',
    text: '租屋',
    originalLink: true,
    target: '_blank',
  },
  {
    href:
      'https://www.sinyi.com.tw/tradeinfo/list?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer',
    text: '實價登錄',
    originalLink: true,
    target: '_blank',
  },
  {
    href: 'https://www.localbond.tw/',
    text: '社區幫官網',
    originalLink: true,
    target: '_blank',
  },
]

// 社群媒體連結
export const SOCIAL_MEDIA_LINKS = [
  {
    icon: <FacebookIconSVG $color={'blue.main'} width="24px" height="24px" />,
    href: 'https://www.facebook.com/livingsinyi',
  },
  {
    icon: <LineCircleSVG width="24px" height="24px" />,
    href: 'https://lin.ee/ekCuLPO',
  },
  {
    icon: <YoutubeIconSVG width="24px" height="24px" />,
    href: 'https://www.youtube.com/@sinyi_living',
  },
]
